/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ReportingControllerGetProjectUsageQueryResponse, ReportingControllerGetProjectUsageQueryParams, ReportingControllerGetProjectUsage400, ReportingControllerGetProjectUsage401, ReportingControllerGetProjectUsage403, ReportingControllerGetProjectUsage404 } from "../../models/reportingController/ReportingControllerGetProjectUsage";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { reportingControllerGetProjectUsage } from "../../clients/reportingService/reportingControllerGetProjectUsage";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const reportingControllerGetProjectUsageQueryKey = (params: ReportingControllerGetProjectUsageQueryParams) => [{
  url: '/api/v1/reporting/projects'
}, ...(params ? [params] : [])] as const;
export type ReportingControllerGetProjectUsageQueryKey = ReturnType<typeof reportingControllerGetProjectUsageQueryKey>;
export function reportingControllerGetProjectUsageQueryOptions(params: ReportingControllerGetProjectUsageQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = reportingControllerGetProjectUsageQueryKey(params);
  return queryOptions<ReportingControllerGetProjectUsageQueryResponse, ResponseErrorConfig<ReportingControllerGetProjectUsage400 | ReportingControllerGetProjectUsage401 | ReportingControllerGetProjectUsage403 | ReportingControllerGetProjectUsage404>, ReportingControllerGetProjectUsageQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return reportingControllerGetProjectUsage(params, config);
    }
  });
}

/**
 * @summary Get contract entitlement and project usage for an organization. projectsUsed is org-wide for the current contract year; projectsCreated honors the team and date filters.
 * {@link /api/v1/reporting/projects}
 */
export function useReportingControllerGetProjectUsage<TData = ReportingControllerGetProjectUsageQueryResponse, TQueryData = ReportingControllerGetProjectUsageQueryResponse, TQueryKey extends QueryKey = ReportingControllerGetProjectUsageQueryKey>(params: ReportingControllerGetProjectUsageQueryParams, options: {
  query?: Partial<QueryObserverOptions<ReportingControllerGetProjectUsageQueryResponse, ResponseErrorConfig<ReportingControllerGetProjectUsage400 | ReportingControllerGetProjectUsage401 | ReportingControllerGetProjectUsage403 | ReportingControllerGetProjectUsage404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? reportingControllerGetProjectUsageQueryKey(params);
  const query = useQuery({
    ...reportingControllerGetProjectUsageQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ReportingControllerGetProjectUsage400 | ReportingControllerGetProjectUsage401 | ReportingControllerGetProjectUsage403 | ReportingControllerGetProjectUsage404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}